$(document).ready(function(){ // cart quantity updates

  // delegate click for plus button
  $(document).on('click', '.i_plus_cart', function(){
      var plus, currrent_qty;
      let $inputBox = $(this).closest('.line_changer').find('input.quantity-input');
      
      currrent_qty = parseInt($inputBox.val()) || 0;
      plus = currrent_qty + 1;
      $inputBox.val(plus);

      var variant_id = $(this).closest('.line_changer').attr("line_var_id");
      updateCartItem(variant_id, plus, 'plus'); 
  });

  // delegate click for minus button
  $(document).on('click', '.i_minus_cart', function(){
      var minus;
      let $inputBox = $(this).closest('.line_changer').find('input.quantity-input');

      minus = parseInt($inputBox.val()) - 1;
      $inputBox.val(minus);

      var variant_id = $(this).closest('.line_changer').attr("line_var_id");
      updateCartItem(variant_id, minus, 'minus'); 
  });

  // optional: if needed for Nectar coins
  $(document).on('click', '#nector-useyourcoins-container', function(){
      // justRefresh(); 
  });

  // trigger when cart is updated
  document.addEventListener("cart:change", function(){
      setTimeout(function(){
          // No need to re-attach events now
      }, 2000);
  }); 

  // update cart items
  function updateCartItem(variant_id, quantity, operation){
      var data = { updates: {} };
      var item_count;

      data.updates[variant_id] = quantity;

      // $(".loading_wait").show();
      // $(".loading_overlay").show();
      startLoader(variant_id);
      setLineDisabled(variant_id, true);

      jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(result) { 
              $.when( 
                  jQuery.getJSON('/cart.js', function(cart) {
                      item_count = cart.item_count;
                      let cartData = cart.items;
                      document.dispatchEvent(new CustomEvent('cart:build' ,{
                          bubbles: true
                      })); 
                      document.dispatchEvent(new CustomEvent('cart:refresh', {
                          bubbles: true,
                          detail: cartData
                      })); 
                  })
              ).then(function(){
                  setTimeout(function(){
                      $(".header__cart-count").find(".count-bubble").html(item_count);
                      // $(".loading_wait").hide();
                      // $(".loading_overlay").hide();
                      stopLoader(variant_id);
                      setLineDisabled(variant_id, false);
                  }, 2000);
              });
          },
          error: function(xhr, status, error) {
              // console.log("Status:", xhr.status);
      
              // $(".loading_wait").hide();
              // $(".loading_overlay").hide();
              stopLoader(variant_id);
              setLineDisabled(variant_id, false);

              $('.line_changer[line_var_id="'+variant_id+'"] input').val(function(_, val) {
                  return Math.max(1, val - 1); // Ensures the value does not go below 1
              });

              let message = $('<p style="color:red;">Not Enough Inventory</p>').insertAfter('.line_changer[line_var_id="'+variant_id+'"]');
              setTimeout(function() {
                  message.fadeOut(300, function() {
                      $(this).remove();
                  });
              }, 2000);
              
          }
      });
  }

  // refresh cart state (not used actively)
  function justRefresh(){
    var data = { updates: {} };
    var item_count;

    // $(".loading_wait").show();
    // $(".loading_overlay").show();
    startLoader(variant_id);
    setLineDisabled(variant_id, true);

    jQuery.ajax({
        type: 'GET',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(result) { 
            $.when( 
                jQuery.getJSON('/cart.js', function(cart) {
                    item_count = cart.item_count;
                    let cartData = cart.items;
                    document.dispatchEvent(new CustomEvent('cart:build' ,{
                        bubbles: true
                    })); 
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: cartData
                    })); 
                })
            ).then(function(){
                setTimeout(function(){
                    // $(".loading_wait").hide();
                    // $(".loading_overlay").hide();
                    stopLoader(variant_id);
                    setLineDisabled(variant_id, false);
                }, 2000);
            });
        }
    });
  }


  function getLineLoader(variant_id) {
    return document.querySelector(
      `.line-item[line_item_var_id="${variant_id}"] pill-loader`
    );
  }

  function startLoader(variant_id) {
    const loader = getLineLoader(variant_id);
    if (loader) loader.setAttribute('aria-busy', 'true');
  }

  function stopLoader(variant_id) {
    const loader = getLineLoader(variant_id);
    if (loader) loader.setAttribute('aria-busy', 'false');
  }

  function setLineDisabled(variant_id, state) {
    const $line = $('.line-item[line_item_var_id="' + variant_id + '"]');
    $line.find('button').prop('disabled', state);
  }



});

document.addEventListener('DOMContentLoaded', function () { //auto-switching tabs in center for all tabbed sections
  const allXTabs = document.querySelectorAll('x-tabs');

  allXTabs.forEach(xTabs => {
    if (!xTabs.shadowRoot) return;

    const shadow = xTabs.shadowRoot;
    const tabButtons = shadow.querySelector('slot[name="title"]')?.assignedElements() || [];

    const tablistContainer = shadow.querySelector('.top-container-tpd');
    if (!tablistContainer) return;

    tabButtons.forEach(button => {
      button.addEventListener('click', function () {
        const containerRect = tablistContainer.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();

        if (buttonRect.left < containerRect.left || buttonRect.right > containerRect.right) {
          const scrollAmount = button.offsetLeft - tablistContainer.offsetWidth / 2 + button.offsetWidth / 2;
          tablistContainer.scrollTo({ left: scrollAmount, behavior: 'smooth' });
        }
      });
    });
  });
});

(function () { // close accordion when current one is opened

  // Exit if collection section exists
  if (document.querySelector('.shopify-section--main-collection')) {
    return;
  }

  const SEL = 'details[is="accordion-disclosure"], accordion-disclosure';

  function isAccordion(el) {
    return !!el && (el.matches?.(SEL));
  }

  // Find the group container so we only close siblings in the same block/section.
  function getGroupRoot(acc) {
    // Prefer a nearby ancestor that actually contains multiple accordions.
    let node = acc.parentElement;
    for (let i = 0; i < 6 && node; i++) {
      const count = node.querySelectorAll(SEL).length;
      if (count > 1) return node;
      node = node.parentElement;
    }
    return acc.parentElement || document; // safe fallback
  }

  function closeSiblingsOf(acc) {
    const root = getGroupRoot(acc);
    const list = root.querySelectorAll(SEL);
    list.forEach((other) => {
      if (other !== acc && other.open) {
        // Use the component's own API so Impact's animation runs
        other.open = false;
      }
    });
  }

  // 1) Capture click on <summary> before Impact toggles 'open'
  document.addEventListener('click', function (e) {
    const summary = e.target.closest('summary');
    if (!summary) return;

    const acc = summary.closest(SEL);
    if (!isAccordion(acc)) return;

    // If it's currently closed, it's about to open -> close others first
    // (We are in capture phase, before the theme flips open state)
    if (!acc.open) {
      closeSiblingsOf(acc);
    }
  }, true); // <- capture

  // 2) Also watch for programmatic opens (Theme Editor, JS) and enforce one-open rule
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        const acc = m.target;
        if (isAccordion(acc) && acc.open) {
          closeSiblingsOf(acc);
        }
      }
    }
  });

  mo.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  // Optional: re-enforce after Shopify section loads in editor/live
  document.addEventListener('shopify:section:load', (evt) => {
    const root = evt.target || document;
    root.querySelectorAll(SEL).forEach((acc) => {
      if (acc.open) closeSiblingsOf(acc);
    });
  });

  $('.buy-buttons button:disabled').click(function(){
    $('.product-info__buy-buttons').append('<div class="error">Please select your options before adding to cart.</div>');
  });
})();



document.addEventListener('click', function(e){

  const btn = e.target.closest('.swatch-more-btn');

  if(!btn) return;

  const targetId = btn.getAttribute('data-target');

  const swatchWrapper = document.getElementById(targetId);

  if(!swatchWrapper) return;

  swatchWrapper.classList.toggle('restrict-height');

  if(swatchWrapper.classList.contains('restrict-height')){

    btn.querySelector('span').innerText = 'More Colors';

    btn.classList.remove('show-all-packs');

  }else{

    btn.querySelector('span').innerText = 'See Less';

    btn.classList.add('show-all-packs');

  }

});